/**
 * Flatten all executor-assignments from a request's vehicleNeeds tree
 * regardless of executor / assignment status. Used by tabs that aggregate
 * delays / ratings across the whole request.
 */
export const collectAssignments = (formContext: any): any[] => {
    const vehicleNeeds: any[] = formContext?.values?.vehicleNeeds || []
    const assignments: any[] = []
    vehicleNeeds.forEach((vn: any) => {
        ;(vn.executors || []).forEach((ex: any) => {
            ;(ex.assignments || []).forEach((a: any) => assignments.push(a))
        })
    })
    return assignments
}

/**
 * Compact label for an assignment used in tab item captions.
 * Combines: ID, driver name, license plate.
 */
export const taskLabel = (task: any): string => {
    const parts: string[] = []
    if (task?.id != null) parts.push(`Завдання #${task.id}`)
    const driver = task?.driver?.fullName || task?.driver?.title
    if (driver) parts.push(driver)
    const plate = task?.vehicle?.registrationNumber || task?.vehicle?.licensePlate
    if (plate) parts.push(plate)
    return parts.join(' · ') || 'Завдання'
}
